exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".toast-custom-success a[data-v-46239be4]{color:#db1f20!important}.toast-custom-error a[data-v-46239be4]{color:#000!important}", ""]);

// exports
